import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

/**
 * Status do parcelamento com as opções do filtro do legado (`InstallmentFilters.tsx:14-19`). Renegociado,
 * refinanciado e vencido existem no fio (`RenderColumnStatusBilling.tsx:37-46`) e aparecem com o rótulo da API.
 */
export const INSTALLMENT_STATUS = defineEnum({
  Created: { label: msg`Em aberto`, tone: 'neutral', icon: 'file-check' },
  Registered: { label: msg`Registrado`, tone: 'info', icon: 'badge-check' },
  Paid: { label: msg`Pago`, tone: 'ok', icon: 'circle-check' },
  Cancelled: { label: msg`Baixado`, tone: 'neutral', icon: 'circle-x' },
});

/** Instrução de protesto (`billing.types.ts` do legado, `firstInstructionDebtCollectionOptions`). */
export const PROTEST_INSTRUCTION = defineEnum({
  '00': { label: msg`Não envia protesto` },
  '06': { label: msg`Protestar automático` },
});

/** Canal de liquidação da baixa (`SettleChargesForm.tsx:31-43`): o fio leva o número. */
export const SETTLEMENT_CHANNEL = defineEnum(
  {
    '0': { label: msg`Pago em Carteira` },
    '1': { label: msg`Pago via COB` },
    '2': { label: msg`Pago via STR` },
    '3': { label: msg`Pago via Cartório` },
    '4': { label: msg`Pago via Dataprev` },
  },
  { order: ['0', '1', '2', '3', '4'], numeric: true },
);

/** Tipo de juros e multa (`utils/enums/index.ts:223-238`). */
export const FEE_TYPE = defineEnum({
  Free: { label: msg`Isento` },
  Percent: { label: msg`Percentual` },
  Money: { label: msg`Valor` },
});

export const INTEREST_CODE = defineEnum({
  ValorDiasUteis: { label: msg`Dias úteis` },
  ValorDiasCorridos: { label: msg`Dias corridos` },
});
